import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@mui/material/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import {styled} from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'
import Paper from '@mui/material/Paper';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import moment from 'moment';
import MaskedInput from 'react-text-mask';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import TicketDetails from './TicketDetails';
import RetrieveCredits from './RetrieveCredits';

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

// const useStyles = makeStyles(theme => ({
//     //root: {
//     //    display: 'flex',
//     //    flexWrap: 'wrap'
//     //},
//     header: {
//         textAlign: 'center',
//         spacing: 10,
//     },
//     //formControl: {
//     //    margin: theme.spacing(1),
//     //    minWidth: 120,

//     //},
//     input: {
//         borderRadius: 4,
//         position: 'relative',
//         color: theme.palette.text.primary,
//         backgroundColor: theme.palette.background.paper,
//         border: '1px solid #ced4da',
//         fontSize: 16,
//         padding: '10px 5px 10px 5px',
//         margin: theme.spacing(1),
//         transition: theme.transitions.create(['border-color', 'box-shadow']),
//         // Use the system font instead of the default Roboto font.
//         fontFamily: [
//             '-apple-system',
//             'BlinkMacSystemFont',
//             '"Segoe UI"',
//             'Roboto',
//             '"Helvetica Neue"',
//             'Arial',
//             'sans-serif',
//             '"Apple Color Emoji"',
//             '"Segoe UI Emoji"',
//             '"Segoe UI Symbol"',
//         ].join(','),
//         '&:focus': {
//             borderRadius: 4,
//             borderColor: '#80bdff',
//             boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
//         },
//     },
//     selectEmpty: {
//         marginTop: theme.spacing(2),
//     },
// }));

function AdminUpdateTicket(props){

    const [ticket, setTicket] = useState(
        props.currentTicket
    );

    const ticketSelector = useSelector((state) => state.ticket.ticket);

    const [months, setMonths] = useState("");
    const [status, setStatus] = useState(0);
    //const [packageList, setPackageList] = useState(
    //    props.packages
    //);
    //let saveTicketRedirect = null;
    const [saveTicketRedirect, setSaveTicketRedirect] = useState(null);
    const [packageSelection, setPackageSelection] = useState(8);
    const [packagesList, setPackagesList] = useState(props.packages);
    const [selectedPackages, setSelectedPackages] = useState({subs: []});
    const [newPassword, setNewPassword] = useState("");


    //const classes = useStyles();

    useEffect(() => {
        props.onInitializeSaveTicket();
        //props.onInitializeRetrieveCredits();
        props.onGetTicket(props.token, props.currentTicketId);
        //props.onGetPackagesList(props.token);

    }, []);

    useEffect(() => {
        setTicket(props.currentTicket);
        setStatus(props.currentTicket.status);
        console.log('current ticket', ticket);
        //setPackageSelection(props.currentClient.package_selection);
        //if (props.currentClient.package_selection === 3){
        //    props.onGetSubPackagesList(props.token, props.currentClientName);
        //}
    }, [props.currentTicket]);

    // useEffect(()=>{
    //     if (props.packages && props.packages.length) {
    //         setPackagesList(props.packages);
    //     }
    // }, [props.packages]);

    // useEffect(()=>{
    //     setSelectedPackages({subs: props.subPackages});
    // }, [props.subPackages]);


    useEffect(() => {
        if (props.isErrorSaveTicket){
            var errorMessage = '' + props.isErrorSaveTicket;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorSaveTicket]);

    // const handleToggle = (event) => {
    //     //const target = event.target;
    //     //const value = target.type === 'checkbox' ? target.checked : target.value;
    //     //const name = target.name;
    //     //const key = target.key;
    //     //setPackagesList({
    //     //    ...packagesList,
    //     //    [name]: {
    //     //        ...packagesList[name],
    //     //        checked: value
    //     //    }
    //     //})
    //     console.log('event name', event.target.name, ' value', event.target.value);
    //     const isChecked = event.target.checked;
    //     if (isChecked){
    //         setSelectedPackages({
    //             subs: [...selectedPackages.subs, event.target.value]
    //         });
    //     } else {
    //         const index = selectedPackages.subs.indexOf(event.target.value);
    //         selectedPackages.subs.splice(index,  1);
    //         setSelectedPackages({
    //             subs: selectedPackages.subs
    //         })
    //     }
    // };

    // let displayCustomPackages = null;
    // if (packageSelection === 3){
    //     displayCustomPackages = (
    //         <Box sx={{ display: 'flex' }}>
    //             <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
    //                 <FormLabel component="legend">Live Packages</FormLabel>
    //                 {Object.keys(packagesList).map((key,value) => {
    //                     if (packagesList[key].type === "tv") {
    //                         return (
    //                             <FormControlLabel
    //                                 control={
    //                                     <Checkbox
    //                                         type="checkbox"
    //                                         onChange={handleToggle}
    //                                         key={key}
    //                                         value={packagesList[key].id}
    //                                         name="subs[]"
    //                                         label={packagesList[key].name}
    //                                         checked={(selectedPackages.subs.includes(packagesList[key].id))?true:false}
    //                                     />
    //                                 }
    //                                 label={packagesList[key].name}
    //                             />
    //                         );
    //                     }
    //                 })}
    //             </FormControl>
    //             <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
    //                 <FormLabel component="legend">VOD Packages</FormLabel>
    //                 {Object.keys(packagesList).map((key,value) => {
    //                     if (packagesList[key].type === "video"){
    //                         return(
    //                             <FormControlLabel
    //                                 control={
    //                                     <Checkbox
    //                                         type="checkbox"
    //                                         onChange={handleToggle}
    //                                         key={key}
    //                                         value={packagesList[key].id}
    //                                         name="subs[]"
    //                                         label={packagesList[key].name}
    //                                         checked={(selectedPackages.subs.includes(packagesList[key].id))?true:false}
    //                                     />
    //                                 }
    //                                 label={packagesList[key].name}
    //                             />
    //                         );
    //                     }

    //                 })}
    //             </FormControl>
    //         </Box>)
    // }


    function validateForm() {
        //if (client.ministra){
        //    return client.description.length < 50 && client.phone.length < 15 && client.password.length > 1;
        //} else {
            return status === 1 && ticketSelector.status === 0;
        //}

    }

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    // const handleChange = (event) => {

    //     const target = event.target;
    //     const value = target.type === 'checkbox' ? target.checked : target.value;
    //     const name = target.name;

    //     const key = target.key;
    //     setClient({
    //         ...client,
    //         [name]: value
    //     })
    // };


    function handleSubmit(event) {
        event.preventDefault();
        const data = {
            id: props.currentTicketId,
            status: status,
        };

        // if (packageSelection === 3 && (selectedPackages.subs.length === packagesList.length || selectedPackages.subs.length < 1)){
        //     var errorMessage = 'If you want to select all packages, then just select ALL PACKAGES from package selection.';
        //     if (selectedPackages.subs.length < 1){
        //         errorMessage = 'Please select at least ONE package or select a pre-defined package from the package selection.';
        //     }
        //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        // } else {
        //     props.onSaveClient(props.token, data);
        // }
        props.onSaveTicket(props.token, data);
    }

    // let displayMacAddress = null;
    // if (!client.ministra){
    //     displayMacAddress = (<FormControl>
    //         <MaskedInput
    //             mask={[/[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':', /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/]}
    //             className={classes.input}
    //             placeholder="Mac Address"
    //             value={client.mac}
    //             guide={true}
    //             id="mac"
    //             name="mac"
    //             onChange={handleChange}
    //         />
    //     </FormControl>);
    // }

    
    
    useEffect(() => {
        if(props.isSuccessSaveTicket){
            console.log('redirecting because', props.isSuccessSaveTicket);
            //props.onGetCredits(props.token);
            console.log('inside save ticket redirect');
            var successMessage = 'Updated ticket ' + props.isSuccessSaveTicket;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
            props.onInitializeSaveTicket();
            setSaveTicketRedirect(<Redirect to="/asupport" />);
        }
    }, [props.isSuccessSaveTicket]);

    return (
        <div>
            {saveTicketRedirect}
            <Grid container spacing={3}>
                <Grid item sm={12} xs={12}>
                    <Paper elevation={5}>
                        <Card>
                            <CardHeader
                                avatar={
                                    (ticketSelector.status === 0) ? <StyledChip label='ACTIVE' sx={{backgroundColor: '#4caf50'}} size="small"/> : <StyledChip label='CLOSED' sx={{backgroundColor: '#f44336'}} size="small"/>                          
                                }
                                title="Update Ticket Status"
                                subheader={props.currentTicketId}
                                titleTypographyProps={{
                                    fontSize: 17,
                                    fontWeight: 'bold'
                                }}
                                subheaderTypographyProps={{
                                    fontSize: 14,
                                }}
                                />
                            <Divider variant="middle" />
                            <CardContent>
                                <form>
                                    <FormGroup row>
                                        <FormControl fullWidth>
                                            <TextField
                                                disabled
                                                id="type"
                                                name="type"
                                                value={ticket.type}
                                                label="Type"
                                                type="text"
                                                
                                            />
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup row>
                                        <FormControl fullWidth>
                                            <TextField
                                                disabled
                                                id="device"
                                                name="device"
                                                value={ticket.device}
                                                label="Device"
                                                type="text"
                                            />
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup row>
                                        <FormControl fullWidth>
                                            <TextField
                                                disabled
                                                id="isp"
                                                name="isp"
                                                value={ticket.isp}
                                                label="Internet Service Provider"
                                                type="text"
                                                
                                            />
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup row>
                                        <FormControl fullWidth>
                                            <TextField
                                                disabled
                                                id="tested"
                                                name="tested"
                                                value={ticket.tested}
                                                label="Tested on another device?"
                                                type="text"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControl fullWidth>
                                            <TextField
                                                disabled
                                                id="description"
                                                name="description"
                                                value={ticket.description}
                                                label="Description"
                                                type="text"
                        
                                            />
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup row>
                                        <FormControl fullWidth>
                                            <InputLabel id="select-status-label">Status</InputLabel>
                                            <Select
                                                disabled={ticketSelector.status === 1}
                                                id="status"
                                                labelId="Select status"
                                                onChange={e => setStatus(e.target.value)}
                                                value={status}
                                            >
                                                <MenuItem value={0}>Active</MenuItem>
                                                <MenuItem value={1}>Issue Resolved</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </FormGroup>
                                </form>
                            </CardContent>
                                <CardActions>
                                    <Button
                                        block
                                        disabled={!validateForm() || props.isLoadingSaveTicket}
                                        type="submit"
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        fullWidth
                                    >
                                        {props.isLoadingSaveTicket
                                            ? spinner
                                            : 'Update'}
                                    </Button>
                                </CardActions>
                        </Card>
                    </Paper>
                </Grid>
                <Grid item sm={12} xs={12} mb={5}>
                    <Paper elevation={5}>
                        <TicketDetails role="admin"/>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        onGetTicket: (token, id) => dispatch(actions.getTicketAdmin(token, id)),
        //onGetPackagesList: (token) => dispatch(actions.packagesList(token)),
        //onGetSubPackagesList: (token, name) => dispatch(actions.subPackagesList(token, name)),
        onSaveTicket: (token, data) => dispatch(actions.saveTicketAdmin(token, data)),
        onInitializeSaveTicket: () => dispatch(actions.initializeSaveTicket()),
        //onInitializeRetrieveCredits: () => dispatch(actions.initializeRetrieveCredits()),
        //onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        //packages: state.packages.package_list,
        //subPackages: state.subPackages.sub_package_list,
        //isLoading: state.packages.loading,
        currentTicketId: state.ticket.id,
        isLoadingSaveTicket: state.saveTicket.loading,
        currentTicket: state.ticket.ticket,
        isErrorSaveTicket: state.saveTicket.error,
        isSuccessSaveTicket: state.saveTicket.ticket

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdateTicket);